export const ALLOCATION_RULE_LABELS = {
  FASTEST_CORRECT: 'ตอบถูกเร็วที่สุด',
  NTH_CORRECT: 'ลำดับที่ N',
  FIRST_N_CORRECT: 'N คนแรกที่ถูก',
  ALL_CORRECT: 'ทุกคนที่ถูก (จำกัดจำนวน)',
  TOP_STAKE_AMONG_WINNERS: 'ยอดแทงสูงสุดในผู้ถูก',
  RANDOM_AMONG_WINNERS: 'สุ่มจากผู้ถูก',
  LOTTERY_DRAW: 'จับฉลาก (Live/Wheel)',
} as const
